<template>
  <div>
    <x-swiper
      :class="_.list"
      :options="swiperOptions"
      @click-slide="handleItemClick"
    >
      <x-swiper-item
        v-for="(item, itemIndex) in goodsList"
        :key="item.id"
        :class="_.item"
      >
        <x-goods-item
          :cover-lazy-load="false"
          :cover-only="true"
          :has-serial-no="true"
          :item="item"
          :index="itemIndex"
          :class="_.goods"
          :track="track"
        />
      </x-swiper-item>
    </x-swiper>
    <div :class="_.info" @click="handleInfoClick">
      <div :class="_.title">{{ goodsList[index].name }}</div>
      <div :class="_.price">
        <div :class="_.current">￥{{ goodsList[index].price }}</div>
        <div v-if="goodsList[index].cost" :class="_.origin">
          ￥{{ goodsList[index].cost }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { defineSwiperOptions } from './swiper'
  import { makeUniGoods } from '@/utils'
  import { navigateTo } from '@/router'

  export default Vue.extend({
    props: {
      data: {
        type: Array,
        required: true,
      },
      track: {
        type: Object,
        default: () => ({}),
      },
    },

    data() {
      return {
        index: 0,
        swiperOptions: defineSwiperOptions({
          slidesPerView: 'auto',
          centeredSlides: true,
          spaceBetween: 0,
          loop: true,
          initialSlide: 0,
          onChange: swiper => (this.index = swiper.realIndex),
        }),
      }
    },

    computed: {
      goodsList() {
        return makeUniGoods(this.data)
      },
    },

    methods: {
      handleItemClick(_, index) {
        navigateTo('GoodsIndex', {
          id: this.goodsList[index].id,
        })
      },
      handleInfoClick() {
        navigateTo('GoodsIndex', {
          id: this.goodsList[this.index].id,
        })
      },
    },
  })
</script>

<style lang="scss" module>
  @use "sass:math";

  .list {
    .item {
      position: relative;
      text-align: center;
      font-size: 0;
      width: percentage(math.div(160, 375));

      &::after {
        content: '';
        display: block;
        padding-bottom: 100%;
      }

      .goods {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        height: 100%;
        transition: all ease 150ms;
        object-fit: cover;
        border-radius: 8px;
      }

      &:not(:global(.swiper-slide-active)) {
        .goods {
          width: percentage(math.div(135, 160));
          height: percentage(math.div(135, 160));
        }
      }
    }
  }

  .info {
    margin-top: 8px;
    text-align: center;

    .title {
      font-size: 16px;
      font-weight: bold;
      color: #333333;
    }

    .price {
      margin-top: 3px;
      display: flex;
      align-items: center;
      justify-content: center;

      .current {
        font-size: 14px;
        font-weight: bold;
        color: #ff111c;
      }

      .origin {
        margin-left: 8px;
        font-size: 14px;
        color: #999999;
        text-decoration: line-through;
      }
    }
  }
</style>
